export default __webpack_public_path__ + "images/email.v-4ec975f9776dde83369ce44416e6b96a.svg";